import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Tabs, Tab, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useTranslation } from '../hooks/useTranslation';
import ProfileTab from '../Componant/Account/ProfileTab';
import SecurityTab from '../Componant/Account/SecurityTab';
import CompanyTab from '../Componant/Account/CompanyTab';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index}>
            {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
        </div>
    );
}

export default function AccountPage() {
    const { isCompanyUser } = usePermissions();
    const t = useTranslation('Profile.json');
    const [searchParams] = useSearchParams();
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        if (searchParams.get('tab') === 'entreprise') {
            setTabValue(2);
        }
    }, [searchParams]);

    return (
        <Box sx={{ p: 3, width: '100%' }}>
            <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
                {t('profile.page_title')}
            </Typography>

            <Card>
                <CardContent>
                    <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                        <Tab label={t('profile.tab.profile')} />
                        <Tab label={t('profile.tab.security')} />
                        {isCompanyUser && <Tab label={t('profile.tab.company')} />}
                    </Tabs>

                    <TabPanel value={tabValue} index={0}>
                        <ProfileTab />
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <SecurityTab />
                    </TabPanel>

                    {isCompanyUser && (
                        <TabPanel value={tabValue} index={2}>
                            <CompanyTab />
                        </TabPanel>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
}
